import React, { useEffect } from 'react';
import {
  HashRouter as Router,
  Routes,
  Route,
  Link,
  useLocation
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./routes/Home";
import News from "./routes/News";
import People from "./routes/People";
import Publication from "./routes/Publication";
import Projects from "./routes/Projects";
import Services from "./routes/Services";
import { ThemeProvider, createTheme } from '@mui/material/styles';

// const theme = createTheme();
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Router>
        <ScrollToTop />
          <div style={{display:"flex", minHeight:"100vh", flexDirection:"column"}}>
            <Navbar />
            <div style={{flex:"1", paddingTop:"52px"}}>
              <Routes>
                <Route exact path="/"  element={<Home/>}/>
                {/* <Route exact path="/news" element={<News/>}/> */}
                {/* <Route exact path="/people" element={<People/>}/> */}
                <Route exact path="/publications" element={<Publication/>}/>
                {/* <Route exact path="/researchs" element={<Projects/>}/> */}
                <Route exact path="/services" element={<Services/>}/>    
              </Routes>
            </div>
            <Footer />
          </div>
        </Router>
      </div>
      </ThemeProvider>
  );
}

export default App;
